import { FC } from 'react';
import styles from './StatCard.module.scss';

export interface StatCardProps {
  label: string;
  value: string;
  subtext: string;
  isLink?: boolean;
  linkHref?: string;
  trendIcon?: string;
}

export const StatCard: FC<StatCardProps> = ({
  label,
  value,
  subtext,
  isLink = false,
  linkHref = '#',
  trendIcon,
}) => {
  return (
    <div className={styles.card}>
      <span className={styles.label}>{label}</span>
      <span className={styles.value}>{value}</span>
      {isLink ? (
        <a href={linkHref} className={`${styles.subtext} ${styles.link}`}>
          {trendIcon && <span className={styles.trendIcon} aria-hidden="true">{trendIcon}</span>}
          <span>{subtext}</span>
        </a>
      ) : (
        <span className={styles.subtext}>
          {trendIcon && <span className={styles.trendIcon} aria-hidden="true">{trendIcon}</span>}
          <span>{subtext}</span>
        </span>
      )}
    </div>
  );
};
